var dealershipModule = angular.module('dealership', ['common']);

dealershipModule.constant('dealershipModuleConstants',
    {
        DEFAULT_PRODUCT: "*DEFAULT*",  // used as a product code, signals that a given object is some kind of default (e.g. default for a product setting)
        RERATE_PRODUCT: "TLC-RERATE-PRODUCT",
        INTERNET_QUOTING: "InternetQuoting"
    }
);
dealershipModule.factory('dealershipEvents', function () {
    return {
        dealerDisplayPreferencesComplete : 'TLC-DEALER-PREFERENCES-COMPLETE'
    };
});
